import { css } from "@/utils/css";
import { isValidDate } from "@/utils/date";
import { __ } from "@wordpress/i18n";
import { formatDate } from "date-fns";
import { v4 as uuid } from "uuid";

type Props = {
    label?: string;
    help?: string;
    value: Date;
    onChange: (value: Date) => void;
    className?: string;
    includeTime?: boolean;
};

export function DateInput({ label, help, value, onChange, className, includeTime }: Props) {
    const id = uuid();

    return (
        <label className={css("date-input", className || "")} htmlFor={id}>
            <span className={css("form-label")}>{label}</span>
            <input
                id={id}
                type={includeTime ? "datetime-local" : "date"}
                className={css("form-input")}
                value={formatDate(value, includeTime ? "yyyy-MM-dd'T'HH:mm" : "yyyy-MM-dd")}
                onChange={(e) => {
                    const date = new Date(e.target.value);
                    if (isValidDate(date)) {
                        onChange(date);
                    }
                }}
            />
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}

export function DateTimeInput({ label, help, value, onChange, className }: Props) {
    const id = uuid();

    return (
        <label className={css("datetime-input", className || "")} htmlFor={id}>
            <span className={css("form-label")}>{label}</span>
            <input
                id={id}
                type="datetime-local"
                className={css("form-input")}
                value={formatDate(value, "yyyy-MM-dd'T'HH:mm")}
                onChange={(e) => {
                    const date = new Date(e.target.value);
                    if (isValidDate(date)) {
                        onChange(date);
                    }
                }}
            />
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
